var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticsNavIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58824 15.8824H16.4118V16.6765H1.58824V15.8824Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17647 7.33392C3.17647 6.74915 3.65052 6.2751 4.23529 6.2751H4.5C5.08477 6.2751 5.55882 6.74915 5.55882 7.33392V15.353H3.17647V7.33392Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41176 1.32353C6.82699 1.32353 6.35294 1.79758 6.35294 2.38235V15.3529H8.73529V2.38235C8.73529 1.79758 8.26124 1.32353 7.67647 1.32353H7.41176Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7059 9.5346C12.7059 8.94983 13.1799 8.47578 13.7647 8.47578H14.0294C14.6142 8.47578 15.0882 8.94983 15.0882 9.5346V15.3529H12.7059V9.5346Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5882 4.89966C10.0035 4.89966 9.52941 5.37371 9.52941 5.95849V15.353H11.9118V5.95849C11.9118 5.37372 11.4377 4.89966 10.8529 4.89966H10.5882Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V18H18V0H0ZM17.2059 0.794118H0.794118V17.2059H17.2059V0.794118Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsNavIcon);
export default __webpack_public_path__ + "static/media/Statistics_Nav_Icon.165a9a99.svg";
export { ForwardRef as ReactComponent };